import { useCalendarApp, ScheduleXCalendar } from "@schedule-x/react";
import { useEffect, useState } from "react";
import {
  createViewDay,
  createViewMonthAgenda,
  createViewMonthGrid,
  createViewWeek,
} from "@schedule-x/calendar";
import { createEventsServicePlugin } from "@schedule-x/events-service";

function DocScheduleCalendar({ docSchedule }) {
  const eventsService = useState(() => createEventsServicePlugin())[0];
    
  const calendar = useCalendarApp({
    views: [
      createViewDay(),
      createViewWeek(),
      createViewMonthGrid(),
      createViewMonthAgenda(),
    ],
    plugins: [eventsService],
  });

  // Watch docSchedule and update events manually
  useEffect(() => {
    if (docSchedule && Array.isArray(docSchedule)){
    eventsService.set(docSchedule);
        }
    }, [docSchedule, eventsService]);

  return <ScheduleXCalendar style={{ width: "100%" }} calendarApp={calendar} />;
}

export default DocScheduleCalendar;
